module.exports = __webpack_public_path__ + "static/media/05_home_page.2316a915.png";